import type { EmailAddress } from './email-address.type.ts';
export interface EmailAddressExtension extends EmailAddress {}
export class EmailAddressExtension {
  get isPersonal() {
    return this.contactType === 'PERSONAL';
  }
}

const Registration = {
  kind: 'object',
  name: 'email-address',
  features: EmailAddressExtension,
};
export default Registration;
